var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
// Utils
import { comparePathsByDepth, getFrom, headOfPath, isObjectOrArrayEmpty, joinPaths, setIn, tailOfPath, } from 'ezyvet-fe-helpers';
import { deriveArrayChanges } from './deriveArrayChanges';
import { resolveNestedObjectsToObjectIds } from '../../changeDetection';
import { resolveObjectIdsToCurrentValue } from './resolveObjectIdsToCurrentValue';
import { createObjectPaths } from '../../objectIdentity';
/**
 * To the given object `values` apply the given list of array changes.
 *
 * @template T extends object
 * @param {T} values
 * @param {ChangeList} changes
 * @param {IndexedStore<object>} newObjects
 * @param {PropertyPathCheck} [isMergeableCheck = undefined]
 *
 * @return {T}
 */
export var applyArrayChanges = function (values, changes, newObjects, isMergeableCheck) {
    if (isMergeableCheck === void 0) { isMergeableCheck = undefined; }
    if (isObjectOrArrayEmpty(changes)) {
        return values;
    }
    var newValues = values;
    var objectPaths = createObjectPaths(newValues);
    var objectId;
    var property;
    var objectPath;
    var propertyPath;
    var newArray;
    var isMergeable;
    var existingArray;
    var index;
    Object.keys(changes)
        // We sort by descending depth so we always perform changes on contained elements before the
        // movement of parent elements change their location
        .sort(comparePathsByDepth).reverse()
        .forEach(function (changePath) {
        objectId = headOfPath(changePath);
        property = tailOfPath(changePath);
        objectPath = objectPaths[objectId];
        if (objectPath === undefined) {
            // nothing to do the object with the property has since been deleted
            return;
        }
        propertyPath = joinPaths(objectPath, property);
        var _a = changes[changePath], oldValue = _a[0], newValue = _a[1];
        newArray = newValue;
        isMergeable = isMergeableCheck === undefined || isMergeableCheck(propertyPath);
        if (isMergeable
            && oldValue !== undefined
            // eslint-disable-next-line no-cond-assign
            && (existingArray = getFrom(newValues, propertyPath)) !== undefined) {
            // Then we need to resolve, otherwise we are gust setting a new array
            newArray = resolveNestedObjectsToObjectIds(existingArray);
            var _b = deriveArrayChanges(oldValue, newValue), order = _b.order, remove = _b.remove;
            remove.forEach(function (valueToRemove) {
                newArray = newArray.filter(function (value) { return value !== valueToRemove; });
            });
            order.forEach(function (orderChange) {
                var after = orderChange.after, value = orderChange.value;
                // This will create a new array, so we don't need a new one when calling splice
                newArray = newArray.filter(function (item) { return item !== value; });
                index = newArray.indexOf(after) + 1;
                newArray = __spreadArray([], newArray);
                newArray.splice(index, 0, value);
            });
        }
        else {
            newArray = newValue;
        }
        // We need to resolve the objectIds in the array
        newArray = newArray.map(function (item) { return resolveObjectIdsToCurrentValue(item, newValues, newObjects); });
        newValues = setIn(newValues, propertyPath, newArray);
    });
    return newValues;
};
//# sourceMappingURL=applyArrayChanges.js.map